import { Button, makeStyles } from '@material-ui/core';
import { FC } from 'react';
import { WbTabStubProps } from './WbTabStub';

const useStyles = makeStyles(theme => ({
  tabs: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
}));

interface WbTabsStubProps {
  tabs: WbTabStubProps[];
}

export const WbTabsStub: FC<WbTabsStubProps> = ({ tabs }) => {
  const classes = useStyles();

  return (
    <div className={classes.tabs}>
      {tabs.map(tab => (
        <Button
          key={tab.name}
          color="primary"
          variant={tab.selected ? 'contained' : 'outlined'}
          size="small"
          onClick={tab.action}
        >
          {tab.label ?? tab.name}
        </Button>
      ))}
    </div>
  );
};
